import React from 'react';

const bottomLinks = [
    { text: 'Privacy Policy', href: 'https://www.tamayou.com/privacy' },
    { text: 'Terms of Service', href: 'https://www.tamayou.com/terms' }
];

const socialLinks = [
    {
        name: "Facebook",
        href: "https://www.facebook.com/tamayouhub",
        icon: "fab fa-facebook-f",
    },
    {
        name: "Instagram",
        href: "https://www.instagram.com/tamayouhub/",
        icon: "fab fa-instagram",
    },
    {
        name: "Twitter",
        href: "https://x.com/tamayou",
        icon: "fa-brands fa-x-twitter",
    },
];

export default function Footer() {
    return (
        <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '0.25rem 0.5rem', // even less vertical space
                    borderTop: '1px solid #e5e7eb',
                    color: '#6b7280',
                    fontSize: '0.625rem', // extra small text
                    width: '100%',
                    maxWidth: '1200px',
                    boxSizing: 'border-box',
                    flexWrap: 'wrap',
                    gap: '0.5rem'
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap' }}>
                    <span>Copyright 2026.</span>
                    {bottomLinks.map((link, index) => (
                        <a
                            key={index}
                            href={link.href}
                            style={{
                                color: '#6b7280',
                                textDecoration: 'none',
                                fontSize: '0.625rem' // match smaller size
                            }}
                        >
                            {link.text}
                        </a>
                    ))}
                </div>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                    {socialLinks.map((social, index) => (
                        <a
                            key={index}
                            href={social.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#000', fontSize: '0.875rem' }} // slightly smaller icons
                        >
                            <i className={social.icon}></i>
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
}
